module.exports = __webpack_public_path__ + "img/bg.15f5cf9a.png";